import * as AllLocalesSupported from 'date-fns/locale';
import { formatDistance, differenceInDays } from 'date-fns';

interface IFormatDateDistanceByLocaleProps {
  dateTextWithTimezone?: string;
  locale?: string;
}

const MIN_DAYS_TO_SHOW_NORMAL_DATE = 28;

const getSupportedLocale = (localeProp = '') => {
  return Object.values(AllLocalesSupported).find(
    (locale) => locale.code === localeProp || locale.code?.includes(localeProp),
  );
};

const parseToCamelCase = (locale = '') => {
  const [prefix, suffix] = locale.split('-');
  const parsePrefix = prefix.toLowerCase();
  const parseSuffix = suffix ? `${suffix.toUpperCase()}` : '';
  return `${parsePrefix}${parseSuffix}`;
};

export const formatDateDistanceByLocale = ({
  dateTextWithTimezone,
  locale: localeProp,
}: IFormatDateDistanceByLocaleProps) => {
  const supportedLocale = getSupportedLocale(localeProp);

  if (!supportedLocale?.code) {
    return;
  }

  try {
    const dateParse = new Date(dateTextWithTimezone || '');
    const dateNow = Date.now();

    if (differenceInDays(dateNow, dateParse) > MIN_DAYS_TO_SHOW_NORMAL_DATE) {
      return dateParse.toLocaleDateString(supportedLocale?.code);
    }

    const locale = { locale: AllLocalesSupported[parseToCamelCase(supportedLocale?.code)] };

    return formatDistance(dateParse, dateNow, {
      ...locale,
    });
  } catch {
    console.error(`Error formatting distance from date ${dateTextWithTimezone} to location ${supportedLocale?.code}`);
  }

  return;
};
